import { App, createAppRouter, createQueryClient, reloadOnStaleChunks, type Extensions } from '@cycling-coach/web/app';
import { createRoot } from 'react-dom/client';
import { IntervalsConnectAction } from './connections/Intervals';
import { ZwiftConnectAction, ZwiftManage } from './connections/Zwift';
import './styles.css';

/**
 * The hosted web app (HOSTED-DECISIONS H1–H2): the public app as a library (DECISIONS #58) with the
 * hosted Connections rows. Hosted routes (register, onboarding, billing) go in `extraRoutes` as
 * constants, public ones in `publicPaths`.
 */
const router = createAppRouter();

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

/** Module scope: the provider memoizes on identity. */
const extensions: Partial<Extensions> = {
  intervalsConnect: { hint: 'Rides, power curves, fitness · workouts to Zwift', action: <IntervalsConnectAction /> },
  zwiftConnect: { hint: 'Connect your Zwift account for zFTP, zMAP and weight', action: <ZwiftConnectAction />, manage: <ZwiftManage /> },
};

reloadOnStaleChunks();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

createRoot(root).render(<App router={router} queryClient={createQueryClient()} extensions={extensions} />);
